import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";
import http from "./HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/user/list";
const apiStatusEndpoint = API_BASE_URL_ENV() + "/user/block";
const apiRemoveEndpoint = API_BASE_URL_ENV() + "/user/admin";

export default class UsersService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	toggleStatus = (id, data) => {
		return http.put(`${apiStatusEndpoint}/${id}`, data);
	};

	remove = (id, data) => {
		return http.delete(`${apiRemoveEndpoint}/${id}`, { data });
	};
}
